/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Site from "@parallelpublicworks/gatsby-clf/src/Site";
const isIframe = require("@parallelpublicworks/clf-utils/isIframe");

// Create Emotion cache with the same key as in gatsby-ssr.js
const key = "clf";
const cache = createCache({ key });

export const wrapRootElement = ({ element }) => {
	return <CacheProvider value={cache}>{element}</CacheProvider>;
};

export const wrapPageElement = ({ element, props }) => {
	return <Site element={element} props={props} />;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
	const { hash } = location;
	let hasToScroll = Boolean(!hash);

	if (hasToScroll)
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}, 200);
};

export const onClientEntry = () => {
	if (isIframe()) {
		// Disable Google Analytics / gtag
		window.gtag = function () {};

		// Disable Fathom Analytics
		window.fathom = {
			trackEvent: function () {},
			trackGoal: function () {},
			blockTrackingForMe: function () {},
		};

	}
};
